import React, { useEffect, useRef } from 'react';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

function Backstage({ImageUrls,VideoUrls}) {

  let imageItemUrls = ImageUrls
  let videoItemUrls = VideoUrls

  const content = {
    titlePart1: 'THE',
    titlePart2: 'BACKSTAGE',
    titlePart3: 'PASS',
    buttonText: 'LISTEN NOW',
    imageSrc: imageItemUrls.image8.url, // Your uploaded image for the right side
    alt : imageItemUrls.image8.altText,
    starIconSrc: 'https://www.svgheart.com/wp-content/uploads/2020/10/-353.png' // Your uploaded image for the star icon
  };

  const containerRef = useRef(null);
  const titlePart1Ref = useRef(null);
  const titlePart2Ref = useRef(null);
  const titlePart3Ref = useRef(null);
  const buttonRef = useRef(null);
  const mainImageRef = useRef(null);
  const starIconRef = useRef(null);

  useEffect(() => {
    const container = containerRef.current;

    // Animation for title parts (staggered)
    gsap.fromTo([titlePart1Ref.current, titlePart2Ref.current, titlePart3Ref.current],
      { opacity: 0, y: 50 },
      {
        opacity: 1,
        y: 0,
        duration: 1,
        ease: 'power3.out',
        stagger: 0.15,
        scrollTrigger: {
          trigger: container,
          start: 'top 80%',
          toggleActions: 'play none none none',
        },
      }
    );

    // Animation for the button
    gsap.fromTo(buttonRef.current,
      { opacity: 0, y: 50 },
      {
        opacity: 1,
        y: 0,
        duration: 1,
        ease: 'power3.out',
        delay: 0.4, // Delay after title animations
        scrollTrigger: {
          trigger: container,
          start: 'top 75%',
          toggleActions: 'play none none none',
        },
      }
    );

    // Animation for the main image
    gsap.fromTo(mainImageRef.current,
      { opacity: 0, scale: 0.9 },
      {
        opacity: 1,
        scale: 1,
        duration: 1.2,
        ease: 'power3.out',
        scrollTrigger: {
          trigger: container,
          start: 'top 80%',
          toggleActions: 'play none none none',
        },
      }
    );

    // Animation for the star icon (pop in)
    gsap.fromTo(starIconRef.current,
      { opacity: 0, scale: 0 },
      {
        opacity: 1,
        scale: 1,
        duration: 0.8,
        ease: 'back.out(1.7)',
        delay: 0.6, // Delay after image animation
        scrollTrigger: {
          trigger: container,
          start: 'top 75%',
          toggleActions: 'play none none none',
        },
      }
    );

  }, []);

  return (
    <>
      <style jsx>{`
        .backstage-container {
          display: flex;
          justify-content: center;
          align-items: center;
          // background-color: #e0e0e0; 
          background-color: #fff; 
          padding: 60px 40px; /* Adjust padding as needed */
          gap: 40px; /* Space between left and right sections */
          flex-wrap: wrap; /* Allow wrapping on smaller screens */
        }

        .backstage-left-section {
          display: flex;
          flex-direction: column;
          align-items: flex-start; /* Align text to the left */
          justify-content: center;
          text-align: left;
          max-width: 400px; /* Limit width for text content */
          padding: 20px; /* Add some padding around the text section */
        }

        .backstage-title-part1 {
          font-family: 'Georgia', serif; /* Similar to the image's "THE" font */
          font-size: 2.5rem;
          font-style: italic;
          color: black;
          margin-bottom: -10px;
        }

        .backstage-title-part2 {
          font-family: 'Impact', 'Arial Black', sans-serif; /* Bold, uppercase font */
          font-size: 5rem; /* Large size for "BACKSTAGE" */
          font-weight: 900;
          letter-spacing: 0.05em;
          text-transform: uppercase;
          color: black;
          margin-bottom: -10px; /* Adjust spacing */
          margin-top: 0;
        }

        .backstage-title-part3 {
          font-family: 'Georgia', serif; /* Similar to "PASS" font */
          font-size: 2.5rem;
          font-style: italic;
          color: black;
          margin-bottom: 30px; /* Space before the button */
          margin-top: 0;
          margin-left: 280px;
        }

        .backstage-listen-button {
          background-color: black;
          color: white;
          font-family: 'Impact','Arial', sans-serif;
          font-size: 1rem;
          padding: 15px 30px;
          border: 2px solid black;
          cursor: pointer;
          text-transform: uppercase;
          transition: background-color 0.3s ease;
        }

        .backstage-listen-button:hover {
          background-color: #fff;
          color : black;
        }

        .backstage-right-section {
          position: relative; /* For positioning the star icon */
          // background-color: #fff; 
          background-color: #808080; 
          padding: 20px; /* Padding around the image */
          border: 1px solid #ccc; /* Subtle border */
          display: flex;
          justify-content: center;
          align-items: center;

        }

        .backstage-main-image {
          max-width: 700px;
          height: 400px;
          display: block;
        }

        .backstage-star-icon {
          position: absolute;
          top: -40px; /* Adjust to position outside the border, as in your image */
          right: -20px; /* Adjust to position outside the border */
          width: 80px; /* Size of the star icon */
          height: auto;
          pointer-events: none; /* Allows clicks to pass through */
          z-index: 1; /* Ensure it's above other elements if needed */
        }

        /* Mobile responsiveness */
        @media (max-width: 768px) {
          .backstage-container {
            flex-direction: column; /* Stack items vertically */
            padding: 30px;
            gap: 30px;
          }

          .backstage-left-section {
            align-items: center; /* Center text on mobile */
            text-align: center;
            max-width: 100%;
            padding: 10px;
          }

          .backstage-title-part1,
          .backstage-title-part2,
          .backstage-title-part3 {
            font-size: 1.8rem; /* Adjust font sizes for mobile */
            margin-bottom: 0;
          margin-left: 0;
          }

          .backstage-title-part2 {
            font-size: 3.5rem;
          }

          .backstage-listen-button {
            padding: 12px 25px;
            font-size: 0.9rem;
          }

          .backstage-right-section {
            width: 90%; /* Make image container take more width */
            padding: 15px;
          }

          .backstage-main-image { /* Adjusted for mobile view */
            max-width: 100%; /* Ensure it fits within its container */
            height: 250px; /* Reduced height for mobile */
            object-fit: cover; /* Ensure image covers the area without distortion */
          }

          .backstage-star-icon {
            top: -10px; /* Adjust star position for mobile */
            right: -10px;
            width: 60px; /* Adjust star size for mobile */
          }
        }
      `}</style>

      <div className="backstage-container" ref={containerRef}>
        <div className="backstage-left-section">
          <h3 className="backstage-title-part1" ref={titlePart1Ref}>{content.titlePart1}</h3>
          <h3 className="backstage-title-part2" ref={titlePart2Ref}>{content.titlePart2}</h3>
          <h3 className="backstage-title-part3" ref={titlePart3Ref}>{content.titlePart3}</h3>
          <button className="backstage-listen-button" ref={buttonRef}>{content.buttonText}</button>
        </div>

        <div className="backstage-right-section">
          <img src={content.imageSrc} alt={content.alt} className="backstage-main-image" ref={mainImageRef} />
          <img src={content.starIconSrc} alt="Star Icon" className="backstage-star-icon" ref={starIconRef} />
        </div>
      </div>
    </>
  );
}

export default Backstage;